import Address from "./address.svelte";
import Balance from './balance.svelte';
import Buy from './buy.svelte';
import Collection from './collection.svelte';
import Card from './card.svelte';
import Connect from './connect.svelte';
import ContractValue from './contractValue.svelte';
import Form from './form.svelte';
import Withdraw from './withdraw.svelte';
import Allowed from './allowed.svelte';
import TogglePrivacy from './togglePrivacy.svelte';
import Faucet from './faucet.svelte';
import Build from './build.svelte';
import Recycle from './recycle.svelte';
import Dispose from './dispose.svelte';
import CoinStats from "./coinStats.svelte";
import Stakeholders from './stakeholders.svelte';
import Usage from './usage.svelte';

import { checkExpression } from "../utils.js";

const expression = document.currentScript.getAttribute('expression');
if (!expression || checkExpression(expression)) {

  const components = {
    address: Address,
    balance: Balance,
    connect: Connect,
    contractValue: ContractValue,
    buy: Buy,
    collection: Collection,
    card: Card,
    form: Form,
    withdraw: Withdraw,
    allowed: Allowed,
    toggleprivacy: TogglePrivacy,
    faucet: Faucet,
    build: Build,
    recycle: Recycle,
    dispose: Dispose,
    coinsStats: CoinStats,
    stakeholders: Stakeholders,
    usage: Usage
  }

  let widget;
  const props = {}
  for (const attr of document.currentScript.attributes) {
    if (attr.name === 'widget') widget = attr.value;
    else if (['value'].includes(attr.name)) props[attr.name] = JSON.stringify(attr.value);
    else if (['texts', "extras"].includes(attr.name)) props[attr.name] = JSON.parse(attr.value);
    else if (!['src', 'expression'].includes(attr.name)) props[attr.name] = attr.value;
  }

  if (Object.keys(components).includes(widget)) {
    new components[widget]({ target: document.currentScript.parentElement, props });
  }
}